import * as axios from "axios";
console.log(process.env);
const API_URL = process.env.REACT_APP_API_URL;

function init(token = null) {
  const api_url = API_URL;

  let headers = {
    Accept: "application/json",
  };

  if (token) headers.Authorization = "Bearer " + token;

  const client = axios.create({
    baseURL: api_url,
    timeout: 61000,
    headers: headers,
  });

  return client;
}

export const verification = (token) => {
  return init().post("/user/verifyemail/" + token);
};

export const getCardById = (id) => {
  return init().get("/card/viewCard/" + id);
};

export const verifyResetPassToken = (token) => {
  return init().get("/user/resetPasswordToken/" + token);
};

export const resetPassword = (token, password) => {
  const params = {
    token: token,
    password: password,
  };
  return init().post("/user/reset-password", params);
};
export const deleteUser = (payload) => {
  return init().delete("/user/delete-user-account", { data: payload });
};
